export default "__VITE_ASSET__XM8yJ6RO__"